/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {ReactCountryFlag} from 'react-country-flag'

type Props = {
  type: string
  label: string
  country: string
}

const TypeCell: FC<Props> = ({type, label, country}) => {

  return (
    <div className='d-flex align-items-center'>
      <div className='overflow-hidden me-3' title={country}>
        <ReactCountryFlag
          countryCode={country}
          style={{ fontSize: '3em' }}
        />
      </div>

      <div className='d-flex flex-column'>
        <span className='text-gray-800 textprimary mb-1'>
          {label}
        </span>
        <span>{type.toUpperCase()}</span>
      </div>
    </div>
  )
}

export {TypeCell}
